var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import Truck from "../assets/Truck";
import CopySvg from "../assets/CopySvg";
import Engine from "../assets/Engine";
import Bus from "../assets/Bus";
import Trailer from "../assets/Trailer";
import RedirectSvg from "../assets/RedirectSvg";
import { useTranslation } from 'react-i18next';
import { getName } from 'country-list';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { RBACWrapper, useHasRoles } from "react-simple-rbac";
import { Link } from "react-router-dom";
import "./equipmentGeneralInfo.scss";
import { fetchPackageByEquipment } from "../../adapters/Subscriptions";
import { getEquipmentOwnerByExternalEquipmentReference } from '../../adapters/EquipmentAdapter';
import Spinner from "../Spinner";
import { WarningSvg } from "../assets";
dayjs.extend(utc);
var EquipmentGeneralInfo = function (props) {
    var _a = useTranslation(), i18n = _a.i18n, t = _a.t;
    var vehicle = props.vehicle;
    var _b = useState([]), customers = _b[0], setCustomers = _b[1];
    var _c = useState(''), selectedCustomer = _c[0], setSelectedCustomer = _c[1];
    var _d = useState(''), customerName = _d[0], setCustomerName = _d[1];
    var _e = useState(true), hasNoCustomer = _e[0], setHasNoCustomer = _e[1];
    var _f = useState(false), customerLoading = _f[0], setCustomerLoading = _f[1];
    var isBasicLimitedUser = useHasRoles(['BasicLimited']);
    var baseURI = process.env.REACT_APP_AZURE_REDIRECT_URI;
    var getCustomerName = function (customerReference) {
        var name = '';
        customers.forEach(function (customer) {
            if (customer.externalCustomerReference === customerReference)
                name = customer.name;
        });
        return name;
    };
    var handleDropdownChange = function (event) {
        setSelectedCustomer(event.target.value);
        setCustomerName(getCustomerName(event.target.value));
    };
    useEffect(function () {
        customers.length === 0 ? setHasNoCustomer(true) : setHasNoCustomer(false);
    }, [customers]);
    useEffect(function () {
        setHasNoCustomer(false);
        setCustomers([]);
        var customersTmp = [];
        var packages = function () { return __awaiter(void 0, void 0, void 0, function () {
            var equipmentOwner, owner, equipmentPackagesResponse, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        setCustomerLoading(true);
                        return [4 /*yield*/, getEquipmentOwnerByExternalEquipmentReference(vehicle.externalEquipmentReference)];
                    case 1:
                        equipmentOwner = _a.sent();
                        owner = {
                            externalCustomerReference: equipmentOwner === null || equipmentOwner === void 0 ? void 0 : equipmentOwner.data.externalCustomerReference,
                            name: equipmentOwner === null || equipmentOwner === void 0 ? void 0 : equipmentOwner.data.name,
                        };
                        customersTmp.push(owner);
                        setSelectedCustomer(owner.externalCustomerReference);
                        setCustomerName(owner.name);
                        return [4 /*yield*/, fetchPackageByEquipment(vehicle.externalEquipmentReference, true)];
                    case 2:
                        equipmentPackagesResponse = _a.sent();
                        equipmentPackagesResponse.data.map(function (p) { return __awaiter(void 0, void 0, void 0, function () {
                            var aCustomer;
                            return __generator(this, function (_a) {
                                aCustomer = {
                                    externalCustomerReference: p.externalCustomerReference,
                                    name: p.customerName,
                                };
                                if (p.subscriptionStatusType === "Active" && !customersTmp.find(function (element) { return element.externalCustomerReference === aCustomer.externalCustomerReference; })) {
                                    customersTmp.push(aCustomer);
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        setCustomers(customersTmp);
                        setCustomerLoading(false);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        setCustomerLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        packages();
    }, [vehicle]);
    var getVehicleIcon = function (vehicleType) {
        switch (vehicleType) {
            case 'Truck': return React.createElement(Truck, null);
            case 'Bus': return React.createElement(Bus, null);
            case 'Engine': return React.createElement(Engine, null);
            case 'Trailer': return React.createElement(Trailer, null);
            default: return '';
        }
    };
    return (React.createElement("div", { className: "equipement" },
        baseURI && React.createElement(React.Fragment, null,
            React.createElement("div", { id: "redirect-url", className: "redirect-link sdds-headline-06" },
                React.createElement(Link, { className: "redirect redirect-link", to: "https://".concat(baseURI.includes('equipment') ? 'servicetroubleshooting' : 'equipment').concat(process.env.REACT_APP_CSTT_DOMAIN, "/").concat(baseURI.includes('equipment') ? 'service-troubleshooting' : 'communication', "/") + vehicle.externalEquipmentReference, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(RedirectSvg, null),
                    baseURI.includes('equipment') ? t("TS_core:GuidedTroubleshooting") : t("TS_core:Equipment"))),
            React.createElement("sdds-tooltip", { placement: "right", selector: "#redirect-url", text: baseURI.includes('equipment') ? t("TS_core:OpenVehicleGuidedTS") : t("TS_core:OpenVehicleEquipment") })),
        React.createElement("div", { className: 'sdds-row section-title' },
            React.createElement("div", { className: 'sdds-no-padding sdds-col-sm-12' },
                React.createElement("span", { className: 'sdds-headline-05' }, t("TS_core:Vehicle").toLocaleUpperCase()))),
        React.createElement("div", { className: "info sdds-body-02" },
            React.createElement("div", { className: 'sdds-row row-margin-top first-row' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t('TS_core:ChassisNumber'))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7 chassis-no' }, vehicle.chassisNumber ? vehicle.chassisNumber : '-')),
            React.createElement(RBACWrapper, { oneOf: true, requiredRoles: ["Admin", "GTS"] },
                React.createElement("div", { className: 'sdds-row row-margin-top eq-type' },
                    React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                        React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t("TS_core:EquipmentType"))),
                    React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7 line-with-icon' },
                        getVehicleIcon((vehicle === null || vehicle === void 0 ? void 0 : vehicle.equipmentType) || ''),
                        vehicle.equipmentType ? vehicle.equipmentType : '-'))),
            !isBasicLimitedUser && React.createElement("div", { className: 'sdds-row row-margin-top cust-line' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t('TS_core:Customer'))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7 cust-actions' },
                    customerLoading && React.createElement(Spinner, { size: "sm" }),
                    customers.length === 1 && React.createElement("span", { className: "cust_name" }, customers[0].name),
                    customers.length > 1 && React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "selectCustomer" },
                            React.createElement("select", { value: selectedCustomer, onChange: handleDropdownChange }, customers.map(function (option, index) { return (React.createElement("option", { key: index, value: option.externalCustomerReference },
                                option.name,
                                " ",
                                index === 0 ? '(' + t('TS_core:VehicleOwner') + ')' : '')); })))),
                    !customerLoading && !hasNoCustomer && React.createElement(React.Fragment, null,
                        React.createElement("button", { onClick: function () { navigator.clipboard.writeText(customerName); } },
                            React.createElement(CopySvg, null)),
                        React.createElement("span", null,
                            React.createElement("a", { className: "link", target: "_blank", href: "https://customer".concat(process.env.REACT_APP_CSTT_DOMAIN, "/customer/").concat(selectedCustomer) },
                                " ",
                                React.createElement(RedirectSvg, null),
                                " "))),
                    !customerLoading && hasNoCustomer && React.createElement("div", { className: "line-with-icon" },
                        React.createElement(WarningSvg, null),
                        " \u00A0",
                        t('TS_core:NoCustomerAvailable')))),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t('TS_core:Vin'))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.identification ? vehicle.identification : '-')),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t('TS_core:RegistrationNumber'))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.registrationNumber ? vehicle.registrationNumber : '-')),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t('TS_core:Alias'))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.alias ? vehicle.alias : '-')),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t("TS_core:Manufacturer"))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.brand ? vehicle.brand : '-')),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t("TS_core:RegistrationCountry"))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.registrationCountry ? getName(vehicle.registrationCountry) : '-')),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t('TS_core:ExternalEquipmentReference'))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7 ext-eq-id' },
                    React.createElement("div", null,
                        vehicle.externalEquipmentReference ? vehicle.externalEquipmentReference : '-',
                        vehicle.externalEquipmentReference &&
                            React.createElement("button", { onClick: function () { navigator.clipboard.writeText(vehicle.externalEquipmentReference); } },
                                React.createElement(CopySvg, null))))),
            React.createElement(RBACWrapper, { oneOf: true, requiredRoles: ["Admin", "GTS"] },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'sdds-row row-margin-top' },
                        React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                            React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t("TS_core:Gateways"))),
                        React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.gateways && vehicle.gateways.length > 0 ? vehicle.gateways.join(',') : '-')),
                    React.createElement("div", { className: 'sdds-row row-margin-top' },
                        React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                            React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" },
                                t("TS_core:TimeCreated"),
                                " (UTC)")),
                        React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' }, vehicle.firstRegistrationDate ? dayjs.utc(vehicle.firstRegistrationDate).format('YYYY-MM-DD HH:mm:ss') : '-')))),
            React.createElement("div", { className: 'sdds-row row-margin-top' },
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-5' },
                    React.createElement("div", { className: "sdds-u-float-left sdds-body-02 bold" }, t("TS_core:ExternalLinks"))),
                React.createElement("div", { className: 'sdds-no-padding sdds-col-md-7' },
                    React.createElement("a", { className: "link", target: "_blank", href: (baseURI && baseURI.includes('prod') ? "https://spii.scania.com/truck/" : "https://web.pii-preprod.devtest.aws.scania.com/truck/") + vehicle.identification + "/productInformation" }, "SPII"),
                    React.createElement("a", { className: "link", target: "_blank", href: "https://whi.scania.com/Pages/User/SearchWorkorder.aspx?chassino=" + vehicle.chassisNumber }, "WHI"),
                    React.createElement("a", { className: "link", target: "_blank", href: "https://operationalanalysis.scania.com/OdsWeb/ExternalInterface/ShowData/" + vehicle.chassisNumber + "/" + (i18n.language || "en-GB") }, "Operational Analysis"))))));
};
export default EquipmentGeneralInfo;
